import api from "utils/api";

export const apiSubscribe = (contactId) => {
  return api.post(`contact/${contactId}/subscribe`);
};

export const apiUnsubscribe = (contactId) => {
  return api.post(`contact/${contactId}/unsubscribe`);
};
